
import { signInResetPasswordFormStyles } from "@insite/content-library/Widgets/SignIn/SignInResetPasswordForm";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import WhitecapColors from "@WhiteCap/Utils/WhiteCapColor";
import { css } from "styled-components";

signInResetPasswordFormStyles.buttonsGridItem = {
	css: css`
		max-width: 100%;
        flex-basis: 100%;
        justify-content: flex-end;
        button{
            span{
                font-size: 15px;
                text-transform: uppercase;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                theme,
                [
                    css`
                        font-size: 12px;
                    `,
                    null,
                    null,
                    null,
                    null
                ],
                "max",
                )}
            }
            &:first-child{
                margin-right: 10px;
            }
        }
		
    `,
}

signInResetPasswordFormStyles.cancelButton = {
    color: "secondary",
	css: css`
		&:hover{
			background: ${WhitecapColors.gray3};
			color: ${WhitecapColors.white};
			opacity: 0.7;
			border-color:  ${WhitecapColors.gray3};
		}
    `,
}

/* 
**** EC-240 - Customer Login ****
*** Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments. */
signInResetPasswordFormStyles.userNameGridItem = {
    width: 12,
    css: css`
        label{
            font-weight: 600;
        }
    `
}
/* *** End: Dynamic CSS refactoring complete. Apply future updates here instead of the CMS.*/